export default {
  // 不在这里加前缀, 在请求层统一处理
  uploadUrl: '/common/file/uploadFile',
}
